module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row section-margin section-margin-top-sm\"> <div id=\"account_balance\"></div> </div> <div class=\"section-margin\"> <div id=\"payment_methods\"></div> </div> <div class=\"section-margin-lg\"> <div id=\"payment_logs\"></div> </div> <div class=\"section-margin-lg\"> <div id=\"cash_flow\"></div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/template.ejs
// module id = 830
// module chunks = 1